import { FetchThemesResponse } from "../../../types/apiResponsesTypes";
import { Theme } from "../../../types/thematiques";
import GenericTable from "../GenericTable";
import useTableThemes from "./hooks/useTableThemes";

type Props = {
  data: FetchThemesResponse | undefined;
  fetchData: (queryParams?: string) => void;
  isLoading: boolean;
  onModify: (id: number) => void;
  onDelete: (id: number) => void;
};

const TableThemes: React.FC<Props> = ({ data, fetchData, isLoading, onModify, onDelete }) => {
  const { columns, onRowClick } = useTableThemes({ onModify, onDelete });

  return (
    <GenericTable<Theme>
      results={data?.results || []}
      count={data?.count || 0}
      columns={columns}
      fetchData={fetchData}
      isLoading={isLoading}
      onRow={onRowClick}
    />
  );
};

export default TableThemes;
